module.exports = __webpack_public_path__ + "img/sketch-black-end.ca44d935.png";